import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import * as actions from '../../store/actions/index';

const ListPosts = props => {
  const { inHome, getPostList } = props;

  useEffect(() => {
    inHome();

    getPostList();
  }, [inHome, getPostList]);

  return (
    <>
      { props.list ? props.list.map((item, index) => {
        return (
          <div className='mb-6 border-b pb-6 bg-white rounded' key={`article-${index}`}>
            <h2 className='font-serif'><NavLink to={item.view_node} className='text-green-darker text-base sm:text-2xl uppercase hover:text-red focus:text-red'>{item.title}</NavLink></h2>
            <div className='mt-5'>
              {item.image ? <img className="mx-auto sm:float-left sm:mt-1 sm:mr-4 mb-0 border border-grey-dark p-2 mb-4" src={props.domain + item.image} alt={item.title} width='220' height='220' /> : null }
              <div className='font-verdana text-grey-darker text-base' dangerouslySetInnerHTML={{ __html: item.body }} />
            </div>
          </div>
        )
      }) : 'Loading...'}
    </>
  )
}

const mapsStateToProps = state => {
  return {
    domain: state.domain,
    isHome: state.isHome,
    list: state.list
  }
}

const mapDispatchToProps = dispatch => {
  return {
    inHome: () => dispatch(actions.inHome()),
    getPostList: () => dispatch(actions.getPostList())
  }
}

export default connect(mapsStateToProps, mapDispatchToProps)(ListPosts);
